import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { API } from '../../lib/api';

export const ReviewsDueBanner = () => {
  const { authHeader } = useAuth();
  const [info, setInfo] = useState(null);
  useEffect(() => {
    axios.get(`${API}/feedback/google-rating`, { headers: authHeader() }).then((r) => setInfo(r.data)).catch(() => {});
  }, [authHeader]);
  if (!info || (!info.due && !info.google?.rating)) return null;
  return (
    <Link to="/admin/feedback" className="mb-6 flex flex-wrap items-center gap-3 rounded-xl border border-amber-400/30 bg-amber-400/10 p-4 transition-colors hover:bg-amber-400/15" data-testid="reviews-due-banner">
      <Star className="text-amber-400" size={20} fill="currentColor" />
      {info.google?.rating && <span className="text-sm font-semibold" data-testid="banner-google-rating">{info.google.rating.toFixed(1)} on Google · {info.google.count} reviews</span>}
      {info.due > 0 && <span className="text-sm" data-testid="banner-reviews-due">{info.due} review request{info.due === 1 ? '' : 's'} due today. Tap to send on WhatsApp</span>}
    </Link>
  );
};
